import React, { useId } from 'react';

/** Text input with `<datalist>` suggestions — replaces Ant Design `Select` `mode="tags"`. */
export function TagsInput({
  value,
  onChange,
  placeholder,
  options = [],
  id: idProp,
  listId: listIdProp,
}) {
  const uid = useId();
  const inputId = idProp ?? `tags-${uid}`;
  const listId = listIdProp ?? `${inputId}-datalist`;

  return (
    <>
      <input
        id={inputId}
        type="text"
        name={inputId}
        list={listId}
        autoComplete="off"
        className="h-10 w-full rounded-[20px] border border-[var(--input)] px-4 outline-none"
        value={value ?? ''}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
      />
      <datalist id={listId}>
        {options.map((o) => (
          <option key={String(o)} value={String(o)} />
        ))}
      </datalist>
    </>
  );
}
